import { Column, CornerLabel, Row, Typography } from '@tempmee/react';
import { colors } from '@tempmee/tailwind';
import { DashboardCard } from '~/components/shared/DashboardCard';

interface IButtonContainerProps {
  variant: 'teal' | 'green';
  title: string;
  description: string;
  ButtonComponent: React.ReactNode;
  FooterComponent?: React.ReactNode;
  disabled?: boolean;
  showNewBadge?: boolean;
}

// DS gradient utilities (from @tempmee/tailwind `backgroundImage` tokens).
const variantGradientClass: Record<'teal' | 'green', string> = {
  teal: 'bg-gradient-brand-dark',
  green: 'bg-gradient-cta',
};

export const ButtonContainer = ({
  variant,
  title,
  description,
  ButtonComponent,
  FooterComponent,
  disabled,
  showNewBadge = false,
}: IButtonContainerProps) => {
  return (
    <DashboardCard
      className={variantGradientClass[variant]}
      style={{
        flex: 1,
        opacity: disabled ? 0.7 : 1,
        position: 'relative',
      }}
    >
      <Column gap={1} px={6} pt={5} pb={6}>
        {showNewBadge && <CornerLabel content="new" label="New" />}
        <Typography size="heading_3" bold color={colors.shades['0']}>
          {title}
        </Typography>
        <Row align="start" justify="between" gap={4}>
          <Typography color={colors.shades['0']} style={{ flex: 1 }}>
            {description}
          </Typography>
          {ButtonComponent}
        </Row>
      </Column>
      {FooterComponent}
    </DashboardCard>
  );
};
